export const styles = () => ({
  arrow: {
    marginLeft: 10,
    width: 20,
    display: 'inline-block',
  },
})

export const customStyles = {
  control: (provided) => ({
    ...provided,
    width: 210,
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    '& > div': {
      justifyContent: 'center',
    },
    '&:hover': {
      border: 'none',
      boxShadow: 'none',
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: 'transparent',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--color-button-primary)',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'var(--color-button-primary)',
    display: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: 'var(--color-button-primary)',
    },
  }),
  menu: (provided) => ({
    ...provided,
    top: 24,
  }),
  option: (provided, state) => {
    return {
      ...provided,
      fontSize: 14,
      cursor: 'pointer',
      backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
      color: 'var(--color-text-primary)',
      '&:hover': {
        fontSize: 14,
        backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
        color: 'var(--color-text-primary)',
      },
    }
  },
}
